export default __webpack_public_path__ + "static/media/1058.12efc001.png";